import React from 'react';
import { useStock } from '../context/StockContext';
export function UrgencyBar() {
  const {
    available
  } = useStock();
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#9D00FF] py-3 px-4" data-id="element-95">
      <p className="text-white text-center font-inter font-semibold text-sm md:text-base stock-critical" data-id="element-96">
        ⚠️ STOCK CRÍTICO: SOLO QUEDAN {available} DE 100 PIEZAS. ENVÍOS EXPRESS
        DISPONIBLES.
      </p>
    </div>;
}